import { SxProps } from '@mui/system';
import { themeObject } from 'lib';

export interface SaveModalProps {
    openSaveModal: boolean;
    saveHeadingText: string;
    saveSubHeadingText?: string;
    saveButtonText: string;
    handleSaveClick: () => void;
    cancelButtonText: string;
    handleCancelClick: () => void;
    customStyles?: SxProps;
    children?: React.ReactNode;
}

export const saveModalStyles = {
    dialogStyles: {
        '& .MuiPaper-root': {
            width: '462px',
            '#dialog-title-container': {
                minHeight: '68px',
            },
            '& .MuiDialogContent-root': {
                p: '0px 35px 35px 35px',
                overflow: 'hidden',
            },
        },
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        mt: 2.5,
    },
    subHeadingTextStyles: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.regular,
        lineHeight: '21.17px',
        color: themeObject.palette.grayScale[800],
    },
};
